// extracted by mini-css-extract-plugin
export default {"header":"styles_header__lm1EH","avatar":"styles_avatar__5DpdX"};